// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b7eb1ae2","220":"837253ce","646":"0081112b","787":"40ef8edb","792":"850e28b2","894":"b37f7100","926":"2924949a"}[chunkId] + ".chunk.js";
};